import React, { useEffect, useMemo, useState } from 'react';
import { selectBaseLegalAditamento } from '../../table-configs/columns-schemas';
import PageWrapper from '../../components/PageWrapper';
import { Grid, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import DefaultTable from '../../components/DefaultTable';
import SaveBox from '../../components/SaveBox';
import lineEndpoint from '../../../../api/services/lineEndpoint';

const FindBaseLegalAditamento = ({ onClose, onSave, listType }) => {
    const [selectedTemp, setSelectedTemp] = useState([]);
    const [loading, setLoading] = useState(false);

    const [rows, setRows] = useState([]);
    const [list, setList] = useState([]);
    const [pageSize, setPageSize] = useState(5);
    const [page, setPage] = useState(0);

    const tableColumns = useMemo(() => {
        return selectBaseLegalAditamento;
    }, []);

    const handleChangePage = (e, page) => {
        setPage(page);
    };

    const handleChangePageSize = (e) => {
        setPageSize(parseInt(e.target.value));
    };

    const prepareRows = (list) => {
        return pageSize > 0 ? list.slice(page * pageSize, page * pageSize + pageSize) : list;
    };

    useEffect(() => {
        (async () => {
            setLoading(true);
            if (listType === 'baseLegal') {
                const response = await lineEndpoint.getBasesLegais();
                if (response && response.status === 200) {
                    setList(
                        response.data.map((entry) => {
                            return {
                                cdCodigo: entry.cdBaseLegal,
                                deDescricao: entry.deBaseLegal,
                            };
                        }),
                    );
                }
            } else {
                const response = await lineEndpoint.getAditamentos();
                if (response && response.status === 200) {
                    setList(
                        response.data.map((entry) => {
                            return {
                                cdCodigo: entry.cdAditamento,
                                deDescricao: entry.deAditamento,
                            };
                        }),
                    );
                }
            }
            setLoading(false);
        })();
    }, [listType]);

    useEffect(() => {
        (() => {
            setRows(prepareRows(list));
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, pageSize, list]);

    const handleSelect = ({ data }) => {
        setSelectedTemp(data);
    };

    const handleSaveSelected = () => {
        if (onSave) {
            onSave(selectedTemp);
        }
        onClose();
    };

    return (
        <PageWrapper
            maxWidth="md"
            title={listType === 'baseLegal' ? 'Base legal' : 'Aditamento'}
            isPlain
            actionButton={
                <IconButton onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            }>
            <Grid item xs={12} container spacing={2}>
                <Grid item xs={12}>
                    <DefaultTable
                        loading={loading}
                        columns={tableColumns}
                        rows={rows}
                        entryProps={{
                            onChangeSelect: handleSelect,
                            selectedId: selectedTemp?.cdCodigo,
                        }}
                        paginationProps={{
                            rowsPerPageOptions: [5, 10, 25],
                            count: list.length || 0,
                            rowsPerPage: pageSize,
                            page: page,
                            onPageChange: handleChangePage,
                            onRowsPerPageChange: handleChangePageSize,
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <SaveBox
                        firstButtonLabel={'VOLTAR'}
                        middleButtonLabel="Adicionar"
                        onSave={handleSaveSelected}
                        onCancel={onClose}
                    />
                </Grid>
            </Grid>
        </PageWrapper>
    );
};

export default FindBaseLegalAditamento;
